import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../../../useAuth";
import { getSettingsProjectAccessRoute } from "../../../../../utils/routes";

interface UseInviteReturnData {
  handleBackClick: () => void;
}

export const useInvite = (): UseInviteReturnData => {
  const navigate = useNavigate();
  const { currentUserType } = useAuth();

  const handleBackClick = (): void => {
    navigate(getSettingsProjectAccessRoute(currentUserType));
  };

  return {
    handleBackClick,
  };
};
